import React, { useState } from 'react';
import Footer from '../components/Footer';

const Appointment = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        address: '',
        description: '',
        date: '',
        time: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, email, contact, address, description, date, time } = formData;
        const message = `Appointment Request:%0AName: ${name}%0AEmail: ${email}%0AContact: ${contact}%0AAddress: ${address}%0ADescription: ${description}%0ADate: ${date}%0ATime: ${time}`;

        const whatsappNumber = 'YOUR_PHONE_NUMBER_WITH_COUNTRY_CODE'; // example: '919876543210'
        const whatsappURL = `https://wa.me/${918100154008}?text=${message}`;

        window.open(whatsappURL, '_blank');
    };

    return (
        <>


            <div className="container my-4">
                <div className="d-flex justify-content-center">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb bg-light p-2 rounded">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Appointment</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div className="container my-5">

                <form onSubmit={handleSubmit} className="row g-3">
                    <div className="col-md-6">
                        <input type="text" name="name" className="form-control" placeholder="Name" onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <input type="email" name="email" className="form-control" placeholder="Email" onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <input type="text" name="contact" className="form-control" placeholder="Contact" onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <input type="text" name="address" className="form-control" placeholder="Address" onChange={handleChange} required />
                    </div>

                    <div className="col-md-6">
                        <input type="date" name="date" className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <input type="time" name="time" className="form-control" onChange={handleChange} required />
                    </div>

                    <div className="col-12">
                        <textarea name="description" className="form-control" placeholder="Description" rows="3" onChange={handleChange} required></textarea>
                    </div>
                    <div className="col-12 text-center">
                        <button type="submit" className="btn btn-success">Submit</button>
                    </div>
                </form>
            </div>
            <Footer />
        </>
    );
};

export default Appointment;
